module.exports = __webpack_public_path__ + "img/draw.26721fa6.svg";